import {createStore, StoreApi} from 'zustand/vanilla';
import {Runner} from '../models/runner';
import {RUN_FULL} from '../models/waypoint';

const cachedFavoriteRunner = window.localStorage.getItem('favorite-runner');
const defaultFavoriteRunner = cachedFavoriteRunner && cachedFavoriteRunner !== 'null' ? (
    new Runner(JSON.parse(cachedFavoriteRunner))
) : null;

const defaultRun = defaultFavoriteRunner ? defaultFavoriteRunner.run : RUN_FULL;

interface RunnersState {
    runners: Array<Runner>;
    favoriteRunner: Runner;
    run: string;
    setRunners: (newRunners: Array<Runner>) => void;
    setFavoriteRunner: (newRunner: Runner) => void;
    removeFavoriteRunner: () => void;
    setCurrentRun: (newRun: string) => void;
}

export type RunnersStore = RunnersState & StoreApi<RunnersState>;

const store = createStore<RunnersState>((set) => ({
    runners: defaultFavoriteRunner ? [defaultFavoriteRunner] : [],
    favoriteRunner: defaultFavoriteRunner,
    run: defaultRun,
    setRunners: (newRunners) => set((state) => {
        const runners = state.favoriteRunner ? [state.favoriteRunner, ...newRunners] : newRunners;
        return {
            ...state,
            runners,
        };
    }),
    setFavoriteRunner: (newFavoriteRunner) => set((state) => {
        window.localStorage.setItem('favorite-runner', JSON.stringify(newFavoriteRunner));

        return {
            ...state,
            favoriteRunner: newFavoriteRunner,
            runners: [newFavoriteRunner],
            run: newFavoriteRunner.run,
        };
    }),
    removeFavoriteRunner: () => set((state) => {
        window.localStorage.removeItem('favorite-runner');

        return {
            ...state,
            favoriteRunner: null,
            runners: [],
        };
    }),
    setCurrentRun: (newRun) => set((state) => ({
        ...state,
        run: newRun,
    })),
}));

export default (): RunnersStore => ({
    ...store.getState(),
    ...store,
});
